
<template>
  <div class="liveData">
    <el-card>
    <div v-if="chartTrue" class="dashboard-show-data" id="myChart"></div>
    </el-card>
  </div>
</template>

<script>
let echarts = require("echarts/lib/echarts");
// 引入柱状图组件
require("echarts/lib/chart/bar");
require("echarts/lib/chart/line");
// 引入提示框和title组件
require("echarts/lib/component/tooltip");
require("echarts/lib/component/legend");
require("echarts/lib/component/title");
export default {
  data() {
    return {
      chartTrue: true,
      liveDetail: {},
      monthLiveUV: [],
      monthRecordUV: [],
      monthUV: []
    };
  },
  methods: {
    getViewerStatistics() {
      this.api.liveRoom
        .getViewerStatistics({
          id: this.$route.query.id
        })
        .then(result => {
          if (result.success) {
            this.liveDetail = result.data;
            for (let item of this.liveDetail.monthLiveUV) {
              this.monthLiveUV.push(item.count);
            }
            for (let item of this.liveDetail.monthRecordUV) {
              this.monthRecordUV.push(item.count);
            }
            for (let item of this.liveDetail.monthUV) {
              this.monthUV.push(item.count);
            }
            this.$nextTick(function() {
              this.drawLine();
            });
            this.$message.success(result.message);
          } else {
            this.$message.error(result.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    drawLine() {
      let myChart = echarts.init(document.getElementById("myChart"));
      myChart.setOption({
        title: {},
        tooltip: {},
        legend: {
          x: "center",
          y: "bottom",
          data: ["直播人数", "录播人数","观看总人数"]
        },
        calculable: true,
        xAxis: {
          data: this.liveDetail.month
        },
        yAxis: {},
        series: [
          {
            name: "直播人数",
            type: "line",
            data: this.monthLiveUV,
            color: ["#24D2B5"],
            itemStyle: {
                normal: {
                  label: {
                    show: true, //开启显示
                    position: "top", //在上方显示
                    textStyle: {
                      //数值样式
                      color: "black",
                      fontSize: 12
                    }
                  }
                }
              }
            
          },
          {
            name: "录播人数",
            type: "line",
            data: this.monthRecordUV,
            color: ["#FFC349"],
            itemStyle: {
                normal: {
                  label: {
                    show: true, //开启显示
                    position: "top", //在上方显示
                    textStyle: {
                      //数值样式
                      color: "black",
                      fontSize: 12
                    }
                  }
                }
              }
          },
          {
            name: "观看总人数",
            type: "line",
            data: this.monthUV,
            color: ["#4D94FF"],
            itemStyle: {
                normal: {
                  label: {
                    show: true, //开启显示
                    position: "top", //在上方显示
                    textStyle: {
                      //数值样式
                      color: "black",
                      fontSize: 12
                    }
                  }
                }
              }
          }]
      },true);
    }
  },
  mounted() {
    this.getViewerStatistics();
  }
};
</script>

<style scoped>
.liveData {
  height: calc(100% - 40px);
}
.dashboard-show-data {
  height: 400px;
  margin-top: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/liveRoom/liveData.vue